module.exports = __webpack_public_path__ + "static/media/sms-star-active.76944b88.svg";